import { render } from "./ClientBox.vue?vue&type=template&id=e966bd20&ts=true"
import script from "./ClientBox.vue?vue&type=script&lang=ts"
export * from "./ClientBox.vue?vue&type=script&lang=ts"

import "./ClientBox.vue?vue&type=style&index=0&id=e966bd20&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__